import { Component, OnInit } from '@angular/core';
import {BaseSelectComponent} from "../base-select/base-select.component";
import {GestionErreursService} from "../../../services/gestion-erreurs.service";
import {take} from "rxjs";
import {AppUtilsService} from "../../../services/internals/app-utils.service";
import {ProcurationService} from "../../../services/repositories/procuration.service";

@Component({
  selector: 'app-select-compte-partage',
  templateUrl: './select-compte-partage.component.html',
  styleUrls: ['./select-compte-partage.component.scss'],
})
export class SelectComptePartageComponent extends BaseSelectComponent implements OnInit {
  constructor(
    private procurationService: ProcurationService,
    private _appUtils: AppUtilsService,
    private _gestionErreursService: GestionErreursService,
  ) {
    super(procurationService, _appUtils, _gestionErreursService);
  }
}